import QRCode from 'qrcode';

const BASE = { margin: 1, errorCorrectionLevel: 'M' as const, color: { dark: '#000000', light: '#ffffff' } };

export function qrDataUrl(text: string, width: number): Promise<string> {
  return QRCode.toDataURL(text, { ...BASE, width });
}

export function qrSvg(text: string): Promise<string> {
  return QRCode.toString(text, { ...BASE, type: 'svg', width: 1024 });
}

export function downloadFile(href: string, filename: string) {
  const a = document.createElement('a');
  a.href = href;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
}

export function displayUrl(url: string): string {
  return url.replace(/^https?:\/\//, '').replace(/\/+$/, '');
}
